const regular = {
    /*  表单自定义验证 布尔值 */
    FormValidateIsTrue(rule, value, callback, isTrue, tips) {
        if (isTrue) {
            callback();
        } else {
            callback(new Error(tips));
        }
    },
    /*  手机号码验证 */
    testPhone: (phone) => {
        var t1 = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (!phone) {
            return false;
        } else {
            if (!(t1.test(phone))) {
                return false;
            } else {
                return true
            }
        }
    },
    /* 用户名为数字、字母、特殊符号的组合 */
    testUserName: (user) => {
        let t1 = /^[a-zA-Z][a-zA-Z0-9_]{4,15}$/;
        if (!user) {
            return false
        } else {
            if (t1.test(user)) {
                return true
            } else {
                return false
            }
        }
    },
    /* 验证码 */
    verificationCode: (code) => {
        let t1 = /^[0-9]{4}$/g
        if (t1.test(code)) {
            return true
        } else {
            return false
        }
    },
    /* 身份证号码 */

    idCard: (val) => {
        let t1 = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        if (t1.test(val)) {
            return true
        } else {
            return false
        }
    },
    /* 银行卡的正则 */
    bankCard: (val) => {
        // let t1 = /^[0-9]\d{11,21}$/
        // ^\d{4,6}([- ]?\d{3,6}){2,4}$
        let t1 = /^\d{4,6}([- ]?\d{3,6}){2,4}$/
        if (t1.test(val)) {
            return true
        } else {
            return false
        }
    },
    /* 社会信用代码 */
    validatecredit: (val) => {
        let t1 = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/
        if (t1.test(val)) {
            return true
        } else {
            return false
        }
    },
    /* 金额校验 */
    validateMoney: (val) => {
        let t1 = /^[0-9]{1,}\.[0-9]{2}$/
        if (t1.test(val)) {
            return true
        } else {
            return false
        }
    },
    /* 密码校验 */
    validatePwd: (val) => {
        let t1 = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!#@*&.])[a-zA-Z\d!#@*&.]{8,}$/
        if (t1.test(val)) {
            return true
        } else {
            return false
        }
    }
};
export default regular;


// WEBPACK FOOTER //
// ./src/util/regular.js